import { IonButton, IonInput } from '@ionic/react';
import { useState } from 'react';
import { FadeText } from '../ui/fade-text';
import BlurFade from '../ui/blur-fade';

const CTA: React.FC = () => {
  const [username, setUsername] = useState('');

  return (
    <div className="relative w-full overflow-hidden flex-1" style={{ minHeight: '100vh' }}>
      <div className="absolute inset-0 w-full h-full" style={{ willChange: 'auto' }}>
        <video
          autoPlay
          loop
          muted
          playsInline
          className="absolute w-full h-full object-cover"
        >
          <source src="/assets/videos/banner.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        <div className="absolute inset-0 bg-black/70"></div>
      </div>

      <div className="relative z-10 flex min-h-svh items-center px-4 md:px-8 lg:px-48">
        <div className="max-w-3xl space-y-6">
          <h1 className="mb-6 text-5xl font-bold tracking-tight text-white md:text-7xl">
            <FadeText
              direction="up"
              framerProps={{
                show: { transition: { delay: 0.2 } },
              }}
              text="Elevate Your"
            />
            <FadeText
              className="text-green-600"
              direction="up"
              framerProps={{
                show: { transition: { delay: 0.3 } },
              }}
              text="Golf Game"
            />
          </h1>

          <FadeText
            className="mb-12 max-w-2xl text-lg text-neutral-200 md:text-xl"
            direction="up"
            framerProps={{
              show: { transition: { delay: 0.3 } },
            }}
            text="Track your progress, analyze your performance, and connect with golfers globally. Share your journey with the world."
          />

          <BlurFade delay={0.6}>
            <div className="flex w-full flex-col items-start gap-4 sm:w-auto sm:flex-row sm:gap-4">
              <div className="relative hidden items-center">
                <span className="absolute left-3 text-lg text-muted-foreground">
                  face.golf/
                </span>
                <IonInput
                  autocomplete="off"
                  value={username}
                  onIonInput={e => setUsername(e.detail.value || '')}
                  className="ion-input-large ion-bg-white"
                  placeholder="tiger-woods"
                />
              </div>
              <IonButton
                expand="block"
                size="large"
                routerLink={`/welcome${username ? `?username=${encodeURIComponent(username.trim())}` : ''}`}
                className="ion-text-wrap"
              >
                Start your journey
              </IonButton>
            </div>
          </BlurFade>
          {/* <Iphone15Pro width={300} height={900}></Iphone15Pro> */}
        </div>
      </div>

      <div className="absolute inset-x-0 bottom-0 h-32 from-black to-transparent dark:bg-gradient-to-t"></div>
    </div>
  );
};

export default CTA;
